import gql from 'graphql-tag'


// Consulta para obtener los datos del informe de "Lista de clientes" de un objetivo de impactos
export const GET_REF_CLIENTS = gql`
  query getRefClients(
    $codDistribuidor: Long!
    $codObjetivo: Int!
    $anio: Int!
    $codEmpleado: Int
    $nivEmpleado: String
    $page: Int!
    $size: Int!
    $searchTerm: String
    $sortBy: String
    $sortDir: String
    $countGroup: Int
    $fromDate: String
    $toDate: String
  ) {
    refClients(
      codDistribuidor: $codDistribuidor
      codObjetivo: $codObjetivo
      anio: $anio
      codEmpleado: $codEmpleado
      nivEmpleado: $nivEmpleado
      page: $page
      size: $size
      searchTerm: $searchTerm
      sortBy: $sortBy
      sortDir: $sortDir
      countGroup: $countGroup
      fromDate: $fromDate
      toDate: $toDate
    ) {
      clientes{
        famPerActual
        pdvId
        famAA
        codPuntoVenta
        pdvName
        segIds
      }
      totalClientes
    }
  }
`

// Consulta para obtener las segmentaciones en objetivos de impactos
export const GET_REF_GROUPS = gql`
  query getRefGroups(
    $codDistribuidor: Long!
    $anio: Int!
    $codObjetivo: Int!
    $withExceptions: Boolean
  ) {
    refGroups(
      codDistribuidor: $codDistribuidor
      anio: $anio
      codObjetivo: $codObjetivo
      withExceptions: $withExceptions
    )
  }
`
// Consulta para obtener el informe de Status de objetivos de impactos
export const GET_REF_STATUS = gql`
  query getRefStatus(
    $codDistribuidor: Long!
    $ano: Int!
    $codObjetivo: Int!
    $fromDate: String
    $toDate: String
  ) {
    refStatus(
      codDistribuidor: $codDistribuidor
      codObjetivo: $codObjetivo
      anio: $ano
      fromDate: $fromDate
      toDate: $toDate
    ) {
      totalImpactosActual
      totalImpactosAA
      statusData {
        numClientesAA
        impactosAA
        numClientes
        impactos
        numFamilias
      }
      totImpactosObjetivo
    }
  }
`

// Consulta para el informe de Detalle por segmentación de objetivos de impactos
export const GET_REF_DETAIL = gql`
  query getRefDetail(
    $codDistribuidor: Long!
    $ano: Int!
    $codObjetivo: Int!
    $fromDate: String
    $toDate: String
  ) {
    refDetail(
      codDistribuidor: $codDistribuidor
      codObjetivo: $codObjetivo
      anio: $ano
      fromDate: $fromDate
      toDate: $toDate
    ) {
      segmentationData {
        segmentacion
        numClientesAA
        numClientes
      }
      totalAcumMesAA
      totalAcumMesActual
      faltantes
      numTotalObjetivo
    }
  }
`

// Consulta para obtener la lista de empleados (y su rol)
export const GET_REF_EMPLEADOS = gql`
  query getRefEmpleados (
    $codDistribuidor: Long!
    $codObjetivo: Int!
    $anio: Int!
  ) {
    refEmpleados(
      codDistribuidor: $codDistribuidor
      codObjetivo: $codObjetivo
      anio: $anio
    ) {
      codEmpleado
      nombreEmpleado
      nivelEmpleado {
        id
        desc
      }
      aplicaJefeEquipo
      aplicaEspecialista
    }
  }
`